import styled from 'styled-components';

export const CTAButtonCell = styled('div')`
  width: auto;
  max-width: fit-content;
  margin: 0 7px;
`;
